import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function PrivacyPage() {
  usePageMeta(
    "Politica de Confidențialitate - Ordell WebCare",
    "Politica de confidențialitate a SC Maze Digital SRL (CUI: RO38272886) pentru serviciul Ordell WebCare."
  );

  return (
    <section data-testid="privacy-page" className="py-16 lg:py-24">
      <div className="section-container max-w-3xl">
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl tracking-tighter leading-none font-bold text-[#1A1D20] mb-8">
          Politica de confidențialitate
        </h1>
        <p className="text-xs text-[#64748B] mb-8">Ultima actualizare: Decembrie 2025</p>

        <div className="prose prose-sm max-w-none space-y-6 text-[#4A5568] leading-relaxed">
          <p>
            SC Maze Digital SRL, cu sediul social în România, CUI: RO38272886, în calitate de operator de date cu caracter personal, se angajează să protejeze confidențialitatea datelor dumneavoastră personale, în conformitate cu Regulamentul (UE) 2016/679 (GDPR).
          </p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">1. Date colectate</h2>
          <p>Prin intermediul formularelor de pe site-ul Ordell WebCare, colectăm următoarele date personale: nume, denumire companie, adresă de email, număr de telefon, adresă website și informații despre problemele tehnice întâmpinate.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">2. Scopul prelucrării</h2>
          <p>Datele sunt colectate în scopul: răspunderii la solicitările dumneavoastră, furnizării serviciilor de mentenanță și suport WordPress, comunicării cu privire la serviciile contractate și îmbunătățirea serviciilor noastre.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">3. Temeiul juridic</h2>
          <p>Prelucrarea datelor se bazează pe: consimțământul dumneavoastră (prin completarea formularului de contact), executarea unui contract sau măsuri precontractuale și interesul nostru legitim de a furniza și îmbunătăți serviciile.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">4. Durata stocării</h2>
          <p>Datele personale sunt stocate pe durata relației contractuale și pentru o perioadă suplimentară conform cerințelor legale aplicabile. Datele colectate prin formularul de contact sunt păstrate pentru o perioadă de maximum 2 ani de la ultima interacțiune.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">5. Drepturile dumneavoastra</h2>
          <p>Aveți dreptul de: acces la datele personale, rectificarea datelor inexacte, ștergerea datelor ("dreptul de a fi uitat"), restricționarea prelucrării, portabilitatea datelor și opoziție la prelucrare. Pentru exercitarea acestor drepturi, ne puteți contacta prin formularul de pe site.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">6. Securitatea datelor</h2>
          <p>Implementăm măsuri tehnice și organizatorice adecvate pentru protecția datelor personale împotriva accesului neautorizat, pierderii sau distrugerii accidentale.</p>

          <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A1D20] !mt-8">7. Contact</h2>
          <p>Pentru orice întrebări legate de prelucrarea datelor personale, ne puteți contacta prin intermediul formularului de contact disponibil pe site.</p>
          <p className="text-sm"><strong>Operator:</strong> SC Maze Digital SRL, CUI: RO38272886</p>
        </div>

        <div className="mt-12">
          <Link to="/" className="text-sm font-medium text-[#0F2942] hover:text-[#0F2942]/80 transition-colors">
            &larr; Înapoi la pagina principală
          </Link>
        </div>
      </div>
    </section>
  );
}
